module.exports = __webpack_public_path__ + "img/doning.9c9e9373.png";